import { useCallback } from 'react';
import { useToast } from '@gluestack-ui/themed';

import { AppToast } from '@/common/components/AppToast';

type ToastAction = 'success' | 'error' | 'warning' | 'info';

/**
 * Toast helper safe inside portals (e.g. Gluestack Modal) where DialogProvider context is unavailable.
 */
export const useAppToast = () => {
  const toast = useToast();

  return useCallback(
    (action: ToastAction, message: string) => {
      toast.show({
        placement: 'bottom',
        render: ({ id }) => (
          <AppToast id={id} action={action} message={message} titleOnly />
        ),
      });
    },
    [toast],
  );
};
